import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-ink px-5 py-16 text-white sm:px-8" data-id="element-37" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto w-full max-w-4xl" data-id="element-38" data-mp="pm2a5rxhz7ex">
        <h2 className="text-center text-3xl font-extrabold tracking-tight sm:text-4xl" data-id="element-39" data-mp="avv122tdr0qw">
          🎁 You Also Get <span className="text-ember" data-id="element-40" data-mp="ft4o5btar0bk">5 Strategic Bonuses</span>
        </h2>
        <p className="mt-3 text-center text-sm text-neutral-400" data-id="element-41" data-mp="1un7tz5q0q3o">
          Included at no extra cost
        </p>

        <div className="mt-6 flex justify-center" data-id="element-42" data-mp="5w8olvldloj5">
          <p className="rounded-full border border-white/10 bg-card px-5 py-2.5 text-sm font-semibold text-neutral-300" data-id="element-43" data-mp="5tw172wumlyp">
            Real value: <span className="font-bold text-ember line-through" data-id="element-44" data-mp="3t06e2moyjx5s">$328</span> —
            today included <span className="font-extrabold text-grass" data-id="element-45" data-mp="1mai4e1bjy4yd">FREE</span>
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-46" data-mp="1r933tyizcklr">
          {bonuses.map((bonus, index) => <article key={bonus.number} className={`flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-card ${index === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:max-w-md' : ''}`} data-id="element-47" data-mp="3ie6hxhdhm1vo" data-mpi={index}>
              <img src={bonus.image} alt={bonus.imageAlt} className="h-44 w-full object-cover sm:h-48" loading="lazy" data-id="element-48" data-mp="3n54xufukcxye" />
              <div className="flex flex-1 flex-col p-5" data-id="element-49" data-mp="2ugh9ucifjuh5">
                <div className="flex items-center justify-between gap-3" data-id="element-50" data-mp="2ui22txp3j5cw">
                  <p className="text-[11px] font-extrabold uppercase tracking-[0.1em] text-ember" data-id="element-51" data-mp="38giiie4xs676">
                    {bonus.number}
                  </p>
                  <p className="text-[11px] font-bold" data-id="element-52" data-mp="33jid85fwv7h4">
                    <span className="text-ember line-through" data-id="element-53" data-mp="noq7ezchlv1b">{bonus.oldPrice}</span>{' '}
                    <span className="text-grass" data-id="element-54" data-mp="ipwub814461o">FREE</span>
                  </p>
                </div>
                <h3 className="mt-3 text-base font-extrabold" data-id="element-55" data-mp="3chv5zseabgnp">{bonus.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-neutral-400" data-id="element-56" data-mp="3hhhpukombv5h">
                  {bonus.description}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}